export const setHeight = (parentId, childId) => {
    if(document.getElementById(parentId)) {
        const height = document.getElementById(parentId).offsetHeight;
        if(document.getElementById(childId) && document.getElementById(childId).style)
            document.getElementById(childId).style.height = `${height - 150}px`;
    }
}